import Accordion from '@mui/material/Accordion';
export default Accordion;
